/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmail = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 3v18H2V3zm-2 3.215-8 7.065-8-7.064V19h16zM18.384 5H5.614L12 10.72z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEmail as Email };
